/* eslint-disable rulesdir/jsx-click-tracking-ids */
import { Color, Spacing } from '@persona-id/design-tokens';
import { EyeIcon, EyeOffIcon } from '@persona-id/design-tokens/icons';
import { repeat } from 'lodash';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import Pii from 'dashboard/components/Pii';
import useToggle from 'lib/hooks/useToggle';

import { TableTD } from './TableLayout';

const ValueFormatter = styled('div')`
  color: ${Color.CoreSlate1000};

  ul,
  ol {
    list-style-position: inside;
  }
`;

const InfoPlaceholder = styled('div')`
  color: ${Color.CoreSlate700};
`;

interface InfoValueProps {
  placeholder: ReactNode;
  show: boolean;
  value?: ReactNode;
  dataTest?: string;
}

const InfoValue: FC<InfoValueProps> = ({ placeholder, show, value, dataTest }) => {
  if (value == null) {
    return <InfoPlaceholder data-test={dataTest}>{placeholder}</InfoPlaceholder>;
  }

  return (
    <ValueFormatter data-test={dataTest}>
      {show ? value : repeat('•', typeof value === 'string' ? value.length : 8)}
    </ValueFormatter>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const IconButtonContainer = styled('div')`
  display: flex;
  padding-left: ${Spacing[2]};

  cursor: pointer;

  svg path {
    transition-duration: 150ms;
  }

  :hover {
    svg path {
      fill: ${Color.CorePurple900};
    }
  }
`;

interface TableMaskTDProps {
  value?: ReactNode;
  isRedacted?: boolean;
  placeholder?: string;
}

const TableMaskTD: FC<TableMaskTDProps> = ({ value, isRedacted, placeholder = '-' }) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const valueAsArray = [].concat(value).filter(Boolean);
  const [show, { toggle: toggleShow }] = useToggle(false);

  return (
    <TableTD>
      <Container>
        {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
        <Pii isRedacted={isRedacted}>
          <div>
            {
              /**
               * If valueAsArray is empty it means all values were nullish.
               * Add a "fake" null to cause a placeholder to render.
               **/
              (valueAsArray.length > 0 ? valueAsArray : [null]).map((v, i) => (
                <InfoValue
                  key={i}
                  dataTest='attribute-item__value'
                  value={v}
                  placeholder={placeholder}
                  show={show}
                />
              ))
            }
          </div>
        </Pii>
        <IconButtonContainer data-test='table-mask-td__toggle' role='button' onClick={toggleShow}>
          {show ? <EyeIcon /> : <EyeOffIcon />}
        </IconButtonContainer>
      </Container>
    </TableTD>
  );
};

export default TableMaskTD;
